/**
 * A fresh id for one attempt at a command whose request carries `request_id`: a repeat with the same id returns the
 * first result, so a retry never applies twice. Keys an attempt; it is not a secret.
 */
export function newRequestId(): string {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  // Only where randomUUID is missing (an insecure origin).
  return "xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx".replace(/x/g, () =>
    Math.floor(Math.random() * 16).toString(16),
  );
}
